// extracted by mini-css-extract-plugin
export default {"app_layout_main":"applayout_app_layout_main__E6+Ha"};